import React from "react";

import pageNotFound from "assets/images/pageNotFound.svg";

import styles from "./PageNotFound.module.scss";

const PageNotFound = () => {
  return (
    <div className={styles.pageNotFoundContainer}>
      <div className={styles.content}>
        <img
          className={styles.illustration}
          src={pageNotFound}
          alt=""
        />
        <h1 className={styles.title}>Page Not Found</h1>
        <p className={styles.bodyText}>
          The page you are looking for does not exist. Please check the link and
          try again.
        </p>
        <p className={styles.supportText}>
          You may reach out to our customer support team at{" "}
          <span className={styles.supportNumber}>1800-570-6262</span> for
          further assistance.
        </p>
      </div>
    </div>
  );
};

export default PageNotFound;
